import { TFunction } from "i18next";
import { formatDeleteInvoicesHeadline, type InvoiceDeleteBreakdown } from "src/utils/invoiceDeleteBreakdown";

const subListStyle = { margin: "4px 0 0", paddingLeft: 16, fontSize: "0.82rem" } as const;

export function DeleteInvoiceCascadeItem({
    t,
    breakdown,
}: {
    t: TFunction;
    breakdown: InvoiceDeleteBreakdown;
}) {
    const headline = formatDeleteInvoicesHeadline(t, breakdown.total, breakdown.open);
    if (!headline) return null;

    const showDunning = breakdown.m1 + breakdown.m2 + breakdown.m3 + breakdown.legal > 0;

    return (
        <li>
            {headline}
            <ul style={subListStyle}>
                <li>
                    {t("recipients.deleteAlsoInvoices_sent", {
                        sent: breakdown.sent,
                        notSent: breakdown.notSent,
                    })}
                </li>
                {showDunning && (
                    <li>
                        {t("recipients.deleteAlsoInvoices_dunning", {
                            m1: breakdown.m1,
                            m2: breakdown.m2,
                            m3: breakdown.m3,
                            legal: breakdown.legal,
                        })}
                    </li>
                )}
            </ul>
        </li>
    );
}
